import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/basic/button";
import Typography from "components/basic/typography";
import { DateField } from "pages/dashboard/pages/calendar/setAvailability/pickers";
import { ReviseQuoteDraft } from "../../types";
import { defaultExpiry } from "../../helpers";

export interface ValiditySectionProps {
  draft: ReviseQuoteDraft;
  quoteValidFor?: string | null;
  onChange: (patch: Partial<ReviseQuoteDraft>) => void;
}

/** How long the revised pricing stands. */
const ValiditySection: React.FC<ValiditySectionProps> = ({
  draft,
  quoteValidFor,
  onChange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
      }}
    >
      <Typography variant="subtitle2">{t("revise.validity")}</Typography>

      <div
        style={{
          display: "flex",
          gap: theme.spacing(2),
          alignItems: "center",
        }}
      >
        <div style={{ flex: 1 }}>
          <DateField
            value={draft.expiresAt}
            minDate={today}
            onChange={(expiresAt) => onChange({ expiresAt })}
          />
        </div>
        <Button
          size="small"
          onClick={() => onChange({ expiresAt: defaultExpiry(quoteValidFor) })}
        >
          {quoteValidFor
            ? t("revise.reset_to", { period: quoteValidFor })
            : t("revise.reset_to_default")}
        </Button>
      </div>

      <Typography
        variant="body2"
        style={{ color: theme.palette.text.secondary }}
      >
        {t("revise.validity_hint")}
      </Typography>
    </div>
  );
};

export default ValiditySection;
